import { bannerStoreActions } from '../store';

export function useBannerActions() {
  return {
    addBannerItem: ({ bannerType, bannerMessage }) =>
      bannerStoreActions.addBannerItem({
        type: bannerType,
        message: bannerMessage,
        id: `${new Date().getTime()}`,
      }),
  };
}
